import { toast } from 'react-toastify';
import { DROP_DOWN_METRICS } from '../components/widgets/world/Metrics/MetricsConstants';

export function parseString(value) {
   if (value === undefined) return '';
   return decodeURIComponent(value);
}

export function parseBoolean(value) {
   if (value === undefined) return false;
   return Boolean(value);
}

export function parseObjectArray(value) {
   if (value === '') {
      return [];
   }
   const stringifiedObjs = decodeURIComponent(value).split(',');

   return stringifiedObjs.map((strObj) => parseObject(strObj));
}

export function parseObject(strObjEncoded) {
   const strObj = decodeURIComponent(strObjEncoded);
   const splitStrObj = strObj.split('~');
   if (splitStrObj.length !== 2) {
      toast.error(
         `URL object type param could not be parsed! String does not contain '~' (received string object: "${strObjEncoded}") Resetting search...`,
      );
      throw Error('Split str obj !== 2');
   }
   let [value, label] = splitStrObj;
   value = decodeURIComponent(value);
   label = decodeURIComponent(label);

   return { value, label };
}

export function parseSimpleObjectArray(value) {
   if (value === '') {
      return [];
   }
   const stringifiedObjs = decodeURIComponent(value).split(',');

   return stringifiedObjs.map((strObj) => {
      const value = parseString(strObj);
      return { value, label: value };
   });
}

// Handles both new compact format ("pi") and old value~label format ("pi~Playout%20%2F%20Ingest")
export function parseWorldmapMetric(value) {
   if (value === undefined || value === '') return null;
   const decoded = decodeURIComponent(value);
   const metricValue = decoded.includes('~') ? decoded.split('~')[0] : decoded;
   const match = DROP_DOWN_METRICS.find((m) => m.value === metricValue);
   return match ? { value: match.value, label: match.label } : { value: metricValue, label: metricValue };
}

// Handles both new compact format ("DE") and old value~label format ("DE~Germany")
export function parseSimpleObjectArrayLegacyCompat(value) {
   if (value === '') {
      return [];
   }
   const stringifiedObjs = decodeURIComponent(value).split(',');
   return stringifiedObjs.map((strObj) => {
      const decoded = decodeURIComponent(strObj);
      const tilde = decoded.indexOf('~');
      const val = tilde >= 0 ? decoded.slice(0, tilde) : decoded;
      return { value: val, label: val };
   });
}

export function parseIntValue(value) {
   // console.log('parseInt :>> ', value);
   const parsedValue = parseInt(value, 10);
   if (isNaN(parsedValue)) {
      toast.error(`URL integer param could not be parsed! (received value: "${value}") Resetting search...`);
      throw Error('Parsed Value is not a number');
   }
   return parsedValue;
}

export function parseDateTime(value) {
   // value from URL should look like: '2024-10-24T16-52-00'
   if (value === undefined || value === '') return '';
   if (value.includes('T')) {
      const splitValues = value.split('T');
      const parsedValueDate = splitValues[0].replaceAll('-', '/');
      const parsedValueTime = splitValues[1].replaceAll('-', ':');
      return `${parsedValueDate} ${parsedValueTime}`;
   } else {
      // console.log(value);

      toast.error(`URL date param could not be parsed! (received value: "${value}") Resetting search...`);
      throw Error('I am not visible to anyone!');
   }
}
